import React from 'react'
import './Home.css'
import Header from '../Header'
import QuickSearch from './QuickSearch'
import Wallpaper from './Wallpaper'

const Home = () => {
  return (
    <>
    <Header />
    <Wallpaper />
    <QuickSearch />
    </>
  )
}

export default Home